import { useEffect } from "react";

const AndroidVideo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);

  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=1bb325452d8867318203652e1ccb20f4&source=embed&photo%5fid=118726401&endOn="
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default AndroidVideo;
